var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@font-face {\r\n  font-family: 'MicrosoftYaHei';\r\n  src: url(" + escape(require("./MicrosoftYaHei.ttf")) + ");\r\n}\r\n\r\n@font-face {\r\n  font-family: 'ysbth';\r\n  src: url(" + escape(require("./ysbth.ttf")) + ");\r\n}\r\n\r\n@font-face {\r\n  font-family: 'DIGITAL';\r\n  src: url(" + escape(require("./DIGITAL.ttf")) + ");\r\n}", "", {"version":3,"sources":["D:/code_workspace/vue_work/ming-iot-admin/src/assets/font/D:/code_workspace/vue_work/ming-iot-admin/src/assets/font/font.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,mCAAiC;CAClC;;AAED;EACE,qBAAqB;EACrB,mCAAwB;CACzB;;AAED;EACE,uBAAuB;EACvB,mCAA0B;CAC3B","file":"font.css","sourcesContent":["@font-face {\r\n  font-family: 'MicrosoftYaHei';\r\n  src: url('./MicrosoftYaHei.ttf');\r\n}\r\n\r\n@font-face {\r\n  font-family: 'ysbth';\r\n  src: url('./ysbth.ttf');\r\n}\r\n\r\n@font-face {\r\n  font-family: 'DIGITAL';\r\n  src: url('./DIGITAL.ttf');\r\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/font/font.css
// module id = 4MNn
// module chunks = 1